export default __webpack_public_path__ + "static/media/reactJS.ae626225.svg";